module.exports = __webpack_public_path__ + "static/media/left-arrow.436a3cd0.png";